import { render, staticRenderFns } from "./SmtBomTable.vue?vue&type=template&id=61af51de&scoped=true"
import script from "./SmtBomTable.vue?vue&type=script&lang=js"
export * from "./SmtBomTable.vue?vue&type=script&lang=js"
import style0 from "./SmtBomTable.vue?vue&type=style&index=0&id=61af51de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af51de",
  null
  
)

export default component.exports